import { Link } from "@tanstack/react-router";

interface AppLinkProps {
  to: string;
  params?: Record<string, string>;
  search?: Record<string, string>;
  title?: string;
  className?: string;
  /** Optional side effect fired on navigation (e.g. mark a notification read). */
  onClick?: (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
  children: React.ReactNode;
}

/**
 * Link through TanStack Router.
 */
export function AppLink({ to, params, search, className, onClick, children }: AppLinkProps) {
  return (
    <Link to={to as "/"} params={params} search={search} className={className} onClick={onClick}>
      {children}
    </Link>
  );
}
